import { render, staticRenderFns } from "./AddOurCourses.vue?vue&type=template&id=6725e5f3&scoped=true&"
import script from "./AddOurCourses.vue?vue&type=script&lang=js&"
export * from "./AddOurCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6725e5f3",
  null
  
)

export default component.exports